import React, { useContext } from 'react';
import { Col, Row, Typography } from 'antd';
import {
  PrinterOutlined,
  AppstoreAddOutlined,
  FileAddOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import TransparentOverlay from '~/App/components/TransparentOverlay';
import i18n from '~/i18n';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import { CartActionContext } from '~/App/Layout/providers/CartProvider';
import { useNavigate } from 'react-router-dom';
import { useCheckPermission } from '~/store/permission';

const { Text } = Typography;

const SavedBottomBar = ({
  disabled,
  onPrint,
}: {
  disabled: boolean;
  onPrint: () => void;
}) => {
  const { order, newOrder } = useContext(OrderContext);
  const { resetCart } = useContext(CartActionContext);
  const navigate = useNavigate();
  const checkPermission = useCheckPermission();

  const buttons = [
    {
      key: 'print',
      text: i18n.t('cart_print'),
      icon: <PrinterOutlined />,
      onClick: onPrint,
    },
    {
      key: 'add',
      text: i18n.t('cart_add_items'),
      icon: <AppstoreAddOutlined />,
      onClick: () => {
        resetCart();
        navigate('/', { replace: true });
      },
    },
    {
      key: 'new',
      text: i18n.t('cart_new_order'),
      icon: <FileAddOutlined />,
      onClick: () => {
        newOrder();
        resetCart();
        navigate('/', { replace: true });
      },
    },
    ...(checkPermission('orderPayment:c')
      ? [
          {
            key: 'pay',
            text: i18n.t('cart_pay'),
            icon: <WalletOutlined />,
            onClick: () => {
              if (order.isNew) return;
              resetCart();
              navigate(`/order/${order.orderId}`);
            },
          },
        ]
      : []),
  ];

  const span = Math.floor(24 / buttons.length);

  return (
    <Row className="cart-bottom-bar-row">
      <TransparentOverlay show={disabled} />
      {buttons.map(({ key, text, icon, onClick }) => (
        <Col
          span={span}
          className="cart-bottom-bar-button"
          onClick={onClick}
          key={key}
        >
          {icon}
          <Text>{text}</Text>
        </Col>
      ))}
    </Row>
  );
};

export default SavedBottomBar;
